<template>
  <div :class="$style['minor-games']">
    <div
      :class="[$style['minor-game'], $style['top']]"
      @click="userStore.toGame('/games/upgrade')"
      @mouseleave="overHover('Upgrade')"
      @mouseover="onHover('Upgrade')"
    >
      <div :class="$style['lottie-upgrade']">
        <client-only>
          <Vue3Lottie
            ref="lottieAnimationUpgrade"
            :animation-data="Upgrade"
            :loop="false"
            :autoplay="false"
          />
        </client-only>
      </div>
      <GameInfo
        :game-name="t('mini_games.upgrade')"
        :game-icon="'UpgradeIcon'"
        :game-class="'minor'"
      />
    </div>
    <div
      :class="[$style['minor-game'], $style['bottom']]"
      @click="userStore.toGame('/games/sapper')"
      @mouseleave="overHover('Sapper')"
      @mouseover="onHover('Sapper')"
    >
      <div :class="$style['lottie-sapper']">
        <client-only>
          <Vue3Lottie
            ref="lottieAnimationSapper"
            :animation-data="Sapper"
            :loop="false"
            :autoplay="false"
          />
        </client-only>
      </div>
      <GameInfo
        :game-name="t('mini_games.sapper')"
        :game-icon="'TowerIcon'"
        :game-class="'minor'"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import GameInfo from "./GameInfo.vue";
import Upgrade from "~/public/mini_games/data.json";
import Sapper from "~/public/mini_games/sapper.json";

const { t } = useI18n();
const userStore = useUserStore();
const lottieAnimationUpgrade = ref(null);
const lottieAnimationSapper = ref(null);

type LottieName = "Upgrade" | "Sapper";

const lottieMap: Record<LottieName, Ref<any>> = {
  Upgrade: lottieAnimationUpgrade,
  Sapper: lottieAnimationSapper,
};

onMounted(() => {
  setTimeout(() => {
    // @ts-ignore
    if (lottieAnimationUpgrade.value) lottieAnimationUpgrade.value.stop();
    // @ts-ignore
    if (lottieAnimationSapper.value) lottieAnimationSapper.value.stop();
  }, 100);
});

const onHover = (name: LottieName) => {
  const lottieRef = lottieMap[name];
  if (lottieRef?.value) {
    // @ts-ignore
    lottieRef.value.setDirection("forward");
    // @ts-ignore
    lottieRef.value.play();
  }
};

const overHover = (name: LottieName) => {
  const lottieRef = lottieMap[name];
  if (lottieRef?.value) {
    // @ts-ignore
    lottieRef.value.setDirection("reverse");
    // @ts-ignore
    lottieRef.value.play();
  }
};
</script>

<style lang="scss" module>
.minor-games {
  display: flex;
  flex-direction: column;
  width: 50%;
  gap: 10px;
  .minor-game {
    position: relative;
    width: 100%;
    height: 50%;
    border-radius: 32px;
    padding: 20px;
    background-color: var(--general-underlay-3-lvl);
    cursor: pointer;
  }
  .top {
    background-image: radial-gradient(
      97.52% 136.84% at 107.94% 139.77%,
      rgba(21, 194, 154, 0.2) 0%,
      rgba(23, 232, 183, 0) 100%
    );
    overflow: hidden;
    .lottie-upgrade {
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
      @media screen and (max-width: 650px) {
        width: 100%;
        top: 17%;
      }
      @media screen and (max-width: 365px) {
        top: 20%;
      }
    }
  }
  .bottom {
    background-image: radial-gradient(
      105.57% 148.08% at 107.94% 139.77%,
      rgba(194, 21, 23, 0.45) 0%,
      rgba(232, 23, 27, 0) 100%
    );
    overflow: hidden;
    .lottie-sapper {
      position: absolute;
      right: 0;
      bottom: 0;
      height: 100%;
      @media screen and (max-width: 650px) {
        width: 100%;
        top: 17%;
      }
      @media screen and (max-width: 365px) {
        top: 20%;
      }
    }
  }
  @media screen and (max-width: 650px) {
    flex-direction: row;
    justify-content: center;
    width: 350px;
    .minor-game {
      width: 172px;
      height: 220px;
      padding: 12px;
    }
  }
  @media screen and (max-width: 375px) {
    width: 100%;
    .minor-game {
      width: 172px;
    }
  }
}
</style>
